import React from 'react';

const LabeledListDescription = ({ description }: { description: string | undefined }) => {
    if (!description) return null;
    return <p className="mt-1 ">{description}</p>;
};
export default LabeledListDescription;
